import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from 'foundations-library/components'

const useStyles = makeStyles((theme) => {
    const { colors } = theme['foundations-library']

    return {
        root: {
            height: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '10px',
            backgroundColor: ({ color }: { color?: string }) => color ?? colors.primary2[500],
            border: ({ showBorder } : { showBorder: boolean }) => showBorder ? '1px solid #02211B' : undefined,
            boxShadow: ({ showBorder } : { showBorder: boolean }) => showBorder ? '-1.5px 1px 0 0 #02211B' : undefined
        },
        circular: {
            width: '20px'
        }
    }
})

interface Props {
    children: React.ReactNode;
    isCircular: boolean;
    color?: string
    showBorder: boolean
}

/**
 * Badge designed to display information (eg. a count of unread messages) for a given nav item on SidebarV2.
 * This should be used like a design component, you may need to create a wrapper component with the logic
 * that actually reads/fetches the necessary data and provides it to this design component.
 * NavItems can be configured to use badge components - see NavConfig in Navigation.tsx.
 */
const SidebarV2Badge = (props: Props) => {
    const classes = useStyles({ color: props.color, showBorder: props.showBorder })

    if (!props.children) {
        return null
    }

    let displayValue = props.children
    if (typeof props.children === 'number') {
        if (props.children <= 0) {
            return null
        } else if (props.children > 9) {
            displayValue = '9+' // Truncated because of the limited space in the circular SidebarV2Badge
        }
    }

    return (
        <span className={`${classes.root} badge ${props.isCircular ? classes.circular : ''}`} data-testid='badge'>
            <Typography tag='span' variant='captionHeavy' color='#fff'>
                {displayValue}
            </Typography>
        </span>
    )
}

SidebarV2Badge.defaultProps = {
    isCircular: true,
    showBorder: false
}

export default SidebarV2Badge
